import axios from 'axios';
import Cookies from 'js-cookie';
import { getAuthHeader, getUserJwtId } from './userInfo-actions';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
);

export const getStoreItems = async filterList => {
  const items = await axios.post(
    `${process.env.REACT_APP_API_STORE}/edustore`,
    {
      filterList,
      username: getUserJwtId()
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (items.data.products) {
    return items.data.products;
  }
};
